export default __webpack_public_path__ + "static/media/search.6095cc55.svg";